import { useEffect, useMemo, useRef, useState } from 'react';
import Preset from './Modal/Preset';
import Size from './Modal/Size';
import Download from './Modal/Download';
import Feedback from './Feedback';
import { presetData } from '../data/presetData';
import { formatData } from '../data/formatData';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import Share from './Modal/Share';
import { useQuery } from './Util';
import Footer from './Footer';

export default function App () {
	const [modal, setModal] = useState('');
	const [outputPreset, setOutputPreset] = useState('square');
	const [outputWidth, setOutputWidth] = useState(1000);
	const [outputHeight, setOutputHeight] = useState(1000);
	const [customAspectRatioWidth, setCustomAspectRatioWidth] = useState(0);
	const [customAspectRatioHeight, setCustomAspectRatioHeight] = useState(0);
	const [uploadedFilename, setUploadedFilename] = useState('');
	const [uploadedContentType, setUploadedContentType] = useState('png');
	const [image, setImage] = useState();

	const cropperRef = useRef();
	const query = useQuery();

	useEffect(function () {
		if (query.get('custom')) {
			const custom = decodeURIComponent(query.get('custom'));
			const parts = custom.split('/');
			if (2 === parts.length) {
				setCustomAspectRatioWidth(parseFloat(parts[0]));
				setCustomAspectRatioHeight(parseFloat(parts[1]));
			}
		} else if (query.get('preset')) {
			setOutputPreset(preset => query.get('preset'));
		}
		setTimeout(function () {
			if (query.get('width')) {
				setOutputWidth(width => parseInt(query.get('width')));
			}
		}, 100);

	}, []);

	useEffect(function () {
		const presetRecord = presetData.find(a => a.id === outputPreset);
		// window.console.log(presetRecord);
		const newWidth = presetRecord.width ? presetRecord.width : outputWidth;
		setOutputWidth(newWidth);
		// window.console.log(outputWidth , presetRecord.aspectRatio, outputWidth / presetRecord.aspectRatio);
		setOutputHeight(Math.round(outputWidth / presetRecord.aspectRatio));

		if (cropperRef.current) {
			cropperRef.current.cropper.setAspectRatio(parseFloat(presetRecord.aspectRatio.toFixed(2)));
		}
	}, [outputPreset, outputWidth]);

	useEffect(function () {
		const presetRecord = presetData.find(a => a.id === outputPreset);
		// window.console.log(outputWidth , presetRecord.aspectRatio, outputWidth / presetRecord.aspectRatio);
		setOutputHeight(Math.round(outputWidth / presetRecord.aspectRatio));
	}, [outputWidth, outputPreset]);

	useEffect(function () {
		if (0 === customAspectRatioHeight || 0 === customAspectRatioWidth) {
			return () => {};
		}

		const aspectRatio = customAspectRatioWidth / customAspectRatioHeight;
		setOutputHeight(Math.round(outputWidth / aspectRatio));

		if (cropperRef.current) {
			cropperRef.current.cropper.setAspectRatio(parseFloat(aspectRatio));
		}
	}, [customAspectRatioWidth, customAspectRatioHeight, outputWidth]);

	function doSetModal (e) {
		setModal(e.target.dataset.modal);
	}

	function doSetFile (e) {
		let files;
		if (e.dataTransfer) {
			files = e.dataTransfer.files;
		} else if (e.target) {
			files = e.target.files;
		}

		const uploadedFormat = formatData.find(format => {
			return format.contentType === files[0].type;
		});

		if (uploadedFormat) {
			setUploadedContentType(uploadedFormat.id);
		}

		setUploadedFilename(files[0].name);

		const reader = new FileReader();
		reader.onload = () => {
			setImage(reader.result);
		};
		reader.readAsDataURL(files[0]);
	};

	function doDeleteImage () {
		setImage(null);
	}

	const presetRecord = useMemo(function () {
		const record = presetData.find(a => a.id === outputPreset);
		if (!record) {
			setOutputPreset('square');
			return false;
		}
		return record;
	}, [outputPreset]);

	const cropperAspectRatio = useMemo(function () {
		if (customAspectRatioHeight > 0 && customAspectRatioWidth > 0) {
			return customAspectRatioWidth / customAspectRatioHeight;
		}

		const record = presetData.find(a => a.id === outputPreset);
		if (!record) {
			return 1;
		}
		return record.aspectRatio;
	}, [customAspectRatioHeight, customAspectRatioWidth, outputPreset]);

	return (
		<>
			{!image && (
				<div className="text-center mb-1 text-black-50">
					Ready to crop an image? Here is what your image will look like:
				</div>
			)}
			<div className="row mt-1 mb-2 mx-0 w-100">
				<button className="  col-xs-12 col-sm-6 row btn text-end text-xs-center"
				        type="button"
				        onClick={doSetModal}
				        data-modal="presets">
					{customAspectRatioHeight > 0 && customAspectRatioWidth > 0 ? (
						<>
							<span className="col text-end">Aspect Ratio:</span>
							<span className="col btn btn-outline-secondary text-dark bg-primary-subtle">
							{customAspectRatioWidth} / {customAspectRatioHeight}
						</span>
						</>
					) : (
						<>
							<span className="col-4 text-end">Shape:</span>
							<span className="col-7 btn btn-outline-secondary text-dark bg-primary-subtle">
							{presetRecord.label}
						</span>
						</>
					)}
				</button>
				{'presets' === modal && (
					<Preset
						setOutputPreset={setOutputPreset}
						setModal={setModal}
						customAspectRatioWidth={customAspectRatioWidth}
						customAspectRatioHeight={customAspectRatioHeight}
						setCustomAspectRatioHeight={setCustomAspectRatioHeight}
						setCustomAspectRatioWidth={setCustomAspectRatioWidth}
					/>
				)}
				<button className=" col-xs-12 col-sm-6 row btn text-start text-xs-center"
				        type="button"
				        onClick={doSetModal}
				        data-modal="size">
					<span className="col-4 text-end">Size:</span>
					<span className="col-8 btn btn-outline-secondary text-dark bg-primary-subtle">
							<>
								{outputWidth}px&nbsp;×&nbsp;{outputHeight}px
							</>
						</span>
				</button>
				{'size' === modal && (
					<Size
						setModal={setModal}
						setOutputWidth={setOutputWidth}
					/>
				)}
			</div>
			{!image && (
				<div className="row mb-4 d-flex gap-3 justify-content-center  w-100">
					<label
						className="col-12 col-sm-8 col-md-8 p-4 position-relative d-flex justify-content-center align-items-center gap-3 rounded"
						style={{
							border: '2px dashed #6c757d',
							cursor: 'pointer',
							color: 'rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important'
						}}>
						<input type="file"
						       onChange={doSetFile}
						       style={{
							       bottom: 0,
							       cursor: 'pointer',
							       left: 0,
							       opacity: 0,
							       pointerEvents: 'all !important',
							       position: 'absolute',
							       right: 0,
							       top: 0,
							       zIndex: 1
						       }}
						/>
						<svg width="2em" height="2em" fill="currentColor" viewBox="0 0 32 32"
						     xmlns="http://www.w3.org/2000/svg">
							<g fill="none" stroke="currentColor"
							   strokeWidth="2">
								<path d="m20 24-8-8L2 26V2h28v22m-14-4 6-6 8 8v8H2v-6"/>
								<circle cx="10" cy="9" r="3"/>
							</g>
						</svg>
						<div>
							Drag your image here or click to select one from your computer.
						</div>

					</label>
				</div>
			)}
			{image && (
				<div className="row mb-3 gap-3 justify-content-center align-items-center w-100 mx-0">
					<div className="col-12 col-sm-6 ">
						<button type="button"
						        onClick={doSetModal}
						        data-modal="download"
						        className="btn btn-secondary w-100">
							Download <span className="d-none d-md-inline">it!</span>
						</button>
						{'download' === modal && (
							<Download setModal={setModal}
							          cropperRef={cropperRef}
							          uploadedFilename={uploadedFilename}
							          uploadedContentType={uploadedContentType}
							          outputPreset={presetRecord}
							          outputWidth={outputWidth}
							          outputHeight={outputHeight}
							/>
						)}
					</div>
					<div className="col-12 col-sm-5 text-center text-sm-start">
						<button type="button"
						        onClick={doSetModal}
						        data-modal="share"
						        className="btn btn-outline-secondary">
							Share <span className="d-none d-md-inline">this cropper</span>
						</button>
						{'share' === modal && (
							<Share setModal={setModal}
							       outputPreset={outputPreset}
							       outputWidth={outputWidth}
							       outputHeight={outputHeight}
							       customAspectRatioWidth={customAspectRatioWidth}
							       customAspectRatioHeight={customAspectRatioHeight}
							/>
						)}
						<button type="button"
						        onClick={doDeleteImage}
						        className="btn btn-link">
							Start over
						</button>
					</div>
				</div>
			)}
			{image && (
				<div className=" mb-3 flex-grow-1 w-100 position-relative">
					<Cropper
						ref={cropperRef}
						src={image}
						aspectRatio={parseFloat(cropperAspectRatio)}
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
						}}
						zoomTo={0.5}
						viewMode={1}
						minCropBoxHeight={10}
						minCropBoxWidth={10}
						background={false}
						responsive={true}
						autoCropArea={1}
						checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
						guides={true}
					/>
				</div>
			)}
			<Footer image={image}/>

			<Feedback modal={modal} setModal={setModal}/>
		</>
	);

}
